<template>
    <div class="select-modal">
        <loader v-if="isLoading"/>
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!usuarioIntegracao && !isUpdate && permissao.create) ||
                        (!usuarioIntegracao && isUpdate && permissao.update)
                    "
                    @click="saveValidations()"
                    :disabled="isSaving || conflito.has"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div
            v-if="conflito.has"
            class="notification is-danger is-light mb-2 p-2"
        >
            {{
                $t("msg-configuracao-conflitante-gerenciador", { n: $t("cliente") })
            }}. <br />
            {{ $t("msg-favor-corrigir") }}
            <hr class="mt-2 mb-2" />
            <p v-if="conflito.config">
                {{
                    $t("msg-conflito-config", { n: conflitoFieldConfig })
                }}
            </p>
            <p v-if="conflito.oculto">
                {{
                    $t("msg-conflito-oculto", { n: conflitoFieldOculto })
                }}
            </p>
        </div>

        <div
            ref="tab-geral"
            class="tab-geral page-container form-columns-fit"
            v-if="!conflito.has"
        >
            <div class="columns is-flex-wrap">
                <!-- 
                Validação de pdadetalhe: *o campo só aparece se tiver pdadetalhe configurado
                oculta - v-if
                label - title - disableMLtitle - tooltipLabel *se tem pdadetalhe não mostra o tooltipLabel
                altera - disabled 
                validchars - validchars
                maxlength - maxlength *caso for zero, pegar na coluna no mysql
                obrigainclusao - required - invalid *verificar no banco se é não null, se for sempre vai ser required
                altera - disabled
                obrigaalteracao - fazer regra no save
                -->
                <div class="column is-4">
                    <v-input
                        :id="generateId(10)"
                        ref="codigo"
                        v-model="cliente.idclienteerp"
                        placeholder="placeholder-preencha"
                        :maxlength="20"
                        title="codigo"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(cliente.idclienteerp)"
                        :required="true"
                        tooltipLabel="informacao-cliente-codigo"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || isUpdate"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(20)"
                        ref="pessoaSelect"
                        title="pessoa"
                        :searchable="false"
                        :options="pessoaSelect"
                        v-model="pessoaSelected"
                        :mlLabels="true"
                        tooltipLabel="informacao-cliente-tipocliente"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || isUpdate"
                        @onBlurFunction="sendIsChanged()"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['estrangeiro'] &&
                        !pdadetalhe['estrangeiro'].oculta
                    "
                >
                    <vss-select
                        :id="generateId(30)"
                        ref="estrangeiro"
                        :title="
                            !isNull(pdadetalhe['estrangeiro'].label)
                                ? pdadetalhe['estrangeiro'].label
                                : 'cliente-estrangeiro'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['estrangeiro'].label)
                        "
                        :msg="pdadetalhe['estrangeiro'].msg"
                        :invalid="false"
                        :required="
                            pdadetalhe['estrangeiro'].obrigainclusao
                        "
                        :searchable="false"
                        :options="estrangeiroSelect"
                        v-model="estrangeiroSelected"
                        :mlLabels="true"
                        :tooltipLabel="
                            isNull(pdadetalhe['estrangeiro'].label)
                                ? 'informacao-cliente-estrangeiro'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit || isUpdate"
                        @onBlurFunction="sendIsChanged('estrangeiro')"
                    />
                </div>
                <!-- 
                Mudanças de campos dependendo da seleção de pessoa cliente.TIPOCLIENTE (0: físico ou 1: jurídico) e cliente.ESTRANGEIRO (1: sim ou 0: não)
                pessoa=0 e estrangeiro=0 | cnpjcpf: CPF, ierg: RG, datanascimento: Data de nascimento, cep: CEP
                pessoa=1 e estrangeiro=0 | cnpjcpf: CNPJ, ierg: Inscrição estadual, datanascimento: Data de fundação, cep: CEP
                pessoa=0 e estrangeiro=1 | cnpjcpf: CI, ierg: não mostra, datanascimento: Data de nascimento, cep: CEP Estrangeiro
                pessoa=1 e estrangeiro=1 | cnpjcpf: RUC, ierg: não mostra, datanascimento: Data de fundação, cep: CEP Estrangeiro
                Na edição, os campos tipo de pessoa e cliente estrangeiro devem ficar bloqueados para edição.
                -->
                <!-- start cnpjcpf ------------------------------------------------------------ -->
                <div
                    class="column is-4"
                    :class="{ loading: isSearchingCNPJ }"
                    v-if="
                        pessoaSelected.id == 1 &&
                        estrangeiroSelected.id == 0 &&
                        pdadetalhe['cnpjcpf'] &&
                        !pdadetalhe['cnpjcpf'].oculta
                    "
                >
                    <v-input
                        :id="generateId(70)"
                        :key="generateId(70)"
                        ref="cnpjcpf"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.cnpjcpf"
                        :title="
                            !isNull(pdadetalhe['cnpjcpf'].label)
                                ? pdadetalhe['cnpjcpf'].label
                                : 'cnpj'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                        placeholder="cnpj-do-cliente-placeholder"
                        :msg="pdadetalhe['cnpjcpf'].msg"
                        :invalid="pdadetalhe['cnpjcpf'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                        v-mask="['##.###.###/####-##']"
                        :icon="!cantEdit 
                            ? pdadetalhe['cidade'] && !pdadetalhe['cidade'].oculta
                                ? 'magnify'
                                : null
                            : null 
                        "
                        @input-action="getInfoByCNPJ"
                        :required="true"
                        :tooltipLabel="
                            isNull(pdadetalhe['cnpjcpf'].label)
                                ? 'informacao-cliente-cnpj'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['cnpjcpf'].altera == 0)
                        "
                    />
                </div>
                <div
                    class="column is-4"
                    v-else-if="
                        pessoaSelected.id == 0 &&
                        estrangeiroSelected.id == 0 &&
                        pdadetalhe['cnpjcpf'] &&
                        !pdadetalhe['cnpjcpf'].oculta
                    "
                >
                    <v-input
                        :id="generateId(80)"
                        :key="generateId(80)"
                        ref="cnpjcpf"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.cnpjcpf"
                        :title="
                            !isNull(pdadetalhe['cnpjcpf'].label)
                                ? pdadetalhe['cnpjcpf'].label
                                : 'cpf'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                        placeholder="cpf-do-cliente-placeholder"
                        :msg="pdadetalhe['cnpjcpf'].msg"
                        :invalid="pdadetalhe['cnpjcpf'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                        :useMask="true"
                        :vMask="['###.###.###-##']"
                        :required="true"
                        :tooltipLabel="
                            isNull(pdadetalhe['cnpjcpf'].label)
                                ? 'informacao-cliente-cpf'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['cnpjcpf'].altera == 0)
                        "
                    />
                </div>
                <div
                    class="column is-4"
                    v-else-if="
                        pessoaSelected.id == 0 &&
                        estrangeiroSelected.id == 1 &&
                        pdadetalhe['cnpjcpf'] &&
                        !pdadetalhe['cnpjcpf'].oculta
                    "
                >
                    <v-input
                        :id="generateId(81)"
                        :key="generateId(81)"
                        ref="cnpjcpf"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.cnpjcpf"
                        :title="
                            !isNull(pdadetalhe['cnpjcpf'].label)
                                ? pdadetalhe['cnpjcpf'].label
                                : 'ci'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                        placeholder="cpf-do-cliente-placeholder"
                        :msg="pdadetalhe['cnpjcpf'].msg"
                        :invalid="pdadetalhe['cnpjcpf'].invalid"
                        :required=" true"
                        @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                        :tooltipLabel="
                            isNull(pdadetalhe['cnpjcpf'].label)
                                ? 'informacao-cliente-ci'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['cnpjcpf'].altera == 0)
                        "
                        :validchars="pdadetalhe['cnpjcpf'].validchars"
                        :maxlength="
                            pdadetalhe['cnpjcpf'].maxlength > 0
                                ? pdadetalhe['cnpjcpf'].maxlength
                                : 20
                        "
                    />
                </div>
                <div
                    class="column is-4"
                    v-else-if="
                        pessoaSelected.id == 1 &&
                        estrangeiroSelected.id == 1 &&
                        pdadetalhe['cnpjcpf'] &&
                        !pdadetalhe['cnpjcpf'].oculta
                    "
                >
                    <v-input
                        :id="generateId(82)"
                        :key="generateId(82)"
                        ref="cnpjcpf"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.cnpjcpf"
                        :title="
                            !isNull(pdadetalhe['cnpjcpf'].label)
                                ? pdadetalhe['cnpjcpf'].label
                                : 'ruc'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['cnpjcpf'].label)"
                        placeholder="cpf-do-cliente-placeholder"
                        :msg="pdadetalhe['cnpjcpf'].msg"
                        :invalid="pdadetalhe['cnpjcpf'].invalid"
                        :required="true"
                        @onBlurFunction="validadeByPdaDetalhe('cnpjcpf')"
                        :tooltipLabel="
                            isNull(pdadetalhe['cnpjcpf'].label)
                                ? 'informacao-cliente-ruc'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['cnpjcpf'].altera == 0)
                        "
                        :validchars="pdadetalhe['cnpjcpf'].validchars"
                        :maxlength="
                            pdadetalhe['cnpjcpf'].maxlength > 0
                                ? pdadetalhe['cnpjcpf'].maxlength
                                : 20
                        "
                    />
                </div>
                <!-- end cnpjcpf -------------------------------------------------------------- -->
                <div
                    class="column is-4"
                    v-if="pdadetalhe['nome'] && !pdadetalhe['nome'].oculta"
                >
                    <v-input
                        :id="generateId(50)"
                        ref="nome"
                        v-model="cliente.nome"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['nome'].label)
                                ? pdadetalhe['nome'].label
                                : 'nome'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['nome'].label)"
                        :msg="pdadetalhe['nome'].msg"
                        :invalid="pdadetalhe['nome'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('nome')"
                        :required="true"
                        :tooltipLabel="
                            isNull(pdadetalhe['nome'].label)
                                ? 'informacao-cliente-nome'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['nome'].altera == 0)
                        "
                        :validchars="pdadetalhe['nome'].validchars"
                        :maxlength="
                            pdadetalhe['nome'].maxlength > 0
                                ? pdadetalhe['nome'].maxlength
                                : 255
                        "
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['rsocial'] && !pdadetalhe['rsocial'].oculta
                    "
                >
                    <v-input
                        :id="generateId(60)"
                        ref="rsocial"
                        v-model="cliente.rsocial"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['rsocial'].label)
                                ? pdadetalhe['rsocial'].label
                                : pessoaSelected.id == 1
                                ? 'razaosocial'
                                : 'sobrenome'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['rsocial'].label)"
                        :invalid="pdadetalhe['rsocial'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('rsocial')"
                        :required="pdadetalhe['rsocial'].obrigainclusao"
                        :msg="pdadetalhe['rsocial'].msg"
                        :tooltipLabel="
                            isNull(pdadetalhe['rsocial'].label)
                                ? pessoaSelected.id == 1
                                    ? 'informacao-cliente-rsocial'
                                    : 'informacao-cliente-sobrenome'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['rsocial'].altera == 0)
                        "
                        :validchars="pdadetalhe['rsocial'].validchars"
                        :maxlength="
                            pdadetalhe['rsocial'].maxlength > 0
                                ? pdadetalhe['rsocial'].maxlength
                                : 255
                        "
                    />
                </div>
                
                <!-- Caso mude o cadastro para pessoa física, caso oculte o campo ierg ou caso não tenha ativo o modulopdadetalhe de ierg,
                o campo cliente.contribuinte recebe o valor de 'null' e deixa de aparecer -->
                <div
                    class="column is-4"
                    v-if="
                        pessoaSelected.id == 1 &&
                        estrangeiroSelected.id == 0 &&
                        pdadetalhe['ierg'] &&
                        !pdadetalhe['ierg'].oculta
                    "
                >
                    <vss-select
                        :id="generateId(89)"
                        ref="contribuinte"
                        title="contribuinte"
                        :searchable="false"
                        :options="contribuinteSelect"
                        v-model="contribuinteSelected"
                        :mlLabels="true"
                        @onBlurFunction="sendIsChanged()"
                        tooltipLabel="informacao-cliente-contribuinte"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                    />
                </div>
                <!-- start ierg --------------------------------------------------------------- -->
                <div
                    class="column is-4"
                    v-if="
                        pessoaSelected.id == 1 &&
                        estrangeiroSelected.id == 0 &&
                        pdadetalhe['ierg'] &&
                        !pdadetalhe['ierg'].oculta &&
                        contribuinteSelected && 
                        contribuinteSelected.id != 'I'
                    "
                >
                    <!-- validchars manualmente, pois não bate com as regras do mobile -->
                    <v-input
                        :id="generateId(90)"
                        :key="generateId(90)"
                        ref="ierg"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.ierg"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['ierg'].label)
                                ? pdadetalhe['ierg'].label
                                : 'ie'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['ierg'].label)"
                        :msg="pdadetalhe['ierg'].msg"
                        :invalid="pdadetalhe['ierg'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('ierg')"
                        :required="pdadetalhe['ierg'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['ierg'].label)
                                ? 'informacao-cliente-ie'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['ierg'].altera == 0)
                        "
                        validchars="0123456789-."
                        :maxlength="
                            pdadetalhe['ierg'].maxlength > 0
                                ? pdadetalhe['ierg'].maxlength
                                : 20
                        "
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pessoaSelected.id == 1 &&
                        estrangeiroSelected.id == 0 &&
                        pdadetalhe['ierg'] &&
                        !pdadetalhe['ierg'].oculta &&
                        contribuinteSelected && 
                        contribuinteSelected.id == 'I'
                    "
                >
                    <v-input
                        :id="generateId(90)"
                        :key="generateId(90)"
                        ref="ierg"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.ierg"
                        :title="
                            !isNull(pdadetalhe['ierg'].label)
                                ? pdadetalhe['ierg'].label
                                : 'ie'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['ierg'].label)"
                        :msg="pdadetalhe['ierg'].msg"
                        :invalid="pdadetalhe['ierg'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('ierg')"
                        :required="pdadetalhe['ierg'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['ierg'].label)
                                ? 'informacao-cliente-ie'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="true"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pessoaSelected.id == 0 &&
                        estrangeiroSelected.id == 0 &&
                        pdadetalhe['ierg'] &&
                        !pdadetalhe['ierg'].oculta
                    "
                >
                    <v-input
                        :id="generateId(91)"
                        :key="generateId(91)"
                        ref="ierg"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.ierg"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        :title="
                            !isNull(pdadetalhe['ierg'].label)
                                ? pdadetalhe['ierg'].label
                                : 'rg'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['ierg'].label)"
                        :msg="pdadetalhe['ierg'].msg"
                        :invalid="pdadetalhe['ierg'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('ierg')"
                        :required="pdadetalhe['ierg'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['ierg'].label)
                                ? 'informacao-cliente-rg'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['ierg'].altera == 0)
                        "
                    />
                </div>
                <!-- end ierg ----------------------------------------------------------------- -->
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['datanascimento'] &&
                        !pdadetalhe['datanascimento'].oculta
                    "
                >
                    <verified-date-picker
                        :id="generateId(40)"
                        ref="datanascimento"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="datanascimento"
                        placeholder="selecione-uma-data"
                        :title="
                            !isNull(pdadetalhe['datanascimento'].label)
                                ? pdadetalhe['datanascimento'].label
                                : pessoaSelected.id == 0
                                ? 'data-nascimento'
                                : 'data-fundacao'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['datanascimento'].label)
                        "
                        :required="pdadetalhe['datanascimento'].obrigainclusao"
                        :invalid="pdadetalhe['datanascimento'].invalid"
                        @onBlurFunction="sendIsChanged('datanascimento')"
                        :msg="pdadetalhe['datanascimento'].msg"
                        :subtractDateYears="80"
                        :yearsRange="[-50, 50]"
                        :inForm="true"
                        :tooltipLabel="
                            isNull(pdadetalhe['datanascimento'].label)
                                ? pessoaSelected.id == 0
                                    ? 'informacao-cliente-datanascimento'
                                    : 'informacao-cliente-datafuncacao'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate &&
                                pdadetalhe['datanascimento'].altera == 0)
                        "
                    />
                </div>
                <!-- Quando for obrigatório o valor inicia com 1 e o mínimo a ser escolhido esté setado para 0,01, seguindo as regras do mobile; Caso contrário o valor mínimo é 0 -->
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['coeftabpreco'] &&
                        !pdadetalhe['coeftabpreco'].oculta
                    "
                >
                    <v-money
                        :id="generateId(41)"
                        ref="coeftabpreco"
                        :title="
                            !isNull(pdadetalhe['coeftabpreco'].label)
                                ? pdadetalhe['coeftabpreco'].label
                                : pessoaSelected.id == 0
                                ? 'coeftabpreco'
                                : 'coeftabpreco'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['coeftabpreco'].label)
                        "
                        placeholder="placeholder-preencha"
                        :msg="pdadetalhe['coeftabpreco'].msg"
                        :invalid="pdadetalhe['coeftabpreco'].invalid"
                        :required="pdadetalhe['coeftabpreco'].obrigainclusao"
                        v-model="cliente.coeftabpreco"
                        :max="10"
                        :min="
                            pdadetalhe['coeftabpreco'].obrigainclusao ? 0.01 : 0
                        "
                        :tooltipLabel="
                            isNull(pdadetalhe['coeftabpreco'].label)
                                ? 'informacao-cliente-coeftabpreco'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['coeftabpreco'].altera == 0)
                        "
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="pdadetalhe['regiao'] && !pdadetalhe['regiao'].oculta"
                >
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(42)"
                                ref="regiao"
                                :title="
                                    !isNull(pdadetalhe['regiao'].label)
                                        ? pdadetalhe['regiao'].label
                                        : 'regiao'
                                "
                                :disableMLtitle="
                                    !isNull(pdadetalhe['regiao'].label)
                                "
                                :msg="pdadetalhe['regiao'].msg"
                                :invalid="pdadetalhe['regiao'].invalid"
                                :required="pdadetalhe['regiao'].obrigainclusao"
                                :clearable="
                                    !pdadetalhe['regiao'].obrigainclusao
                                "
                                :searchable="false"
                                :options="regiaoSelect"
                                v-model="regiaoSelected"
                                :mlLabels="false"
                                :tooltipLabel="
                                    isNull(pdadetalhe['regiao'].label)
                                        ? 'informacao-cliente-regiao'
                                        : null
                                "
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :disabled="
                                    cantEdit ||
                                    (isUpdate &&
                                        pdadetalhe['regiao'].altera == 0)
                                "
                                @onBlurFunction="sendIsChanged('regiao')"
                            />
                        </div>
                        <div class="control padding-label padding-label-custom">
                            <b-button
                                @click="showModalCadastroRegiao = true"
                                icon-right="plus"
                                v-tippy 
                                :title="$t('adicionar') +
                                ' ' +
                                $t('regiao')"
                            />
                        </div>
                    </div>
                    <b-modal :active.sync="showModalCadastroRegiao">
                        <div>
                            <RegiaoCadastroModal
                                v-if="showModalCadastroRegiao"
                                @fecharModal="
                                    fecharModalRegiaoWithValue($event)
                                "
                            />
                        </div>
                    </b-modal>
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['atividade'] &&
                        !pdadetalhe['atividade'].oculta
                    "
                >
                    <vss-select
                        :id="generateId(43)"
                        ref="atividade"
                        :title="
                            !isNull(pdadetalhe['atividade'].label)
                                ? pdadetalhe['atividade'].label
                                : 'atividade'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['atividade'].label)"
                        :msg="pdadetalhe['atividade'].msg"
                        :invalid="pdadetalhe['atividade'].invalid"
                        :required="pdadetalhe['atividade'].obrigainclusao"
                        :clearable="!pdadetalhe['atividade'].obrigainclusao"
                        :options="atividadeSelect"
                        v-model="atividadeSelected"
                        :searchable="true"
                        @search="loadAtividades($event)"
                        :mlLabels="false"
                        :tooltipLabel="
                            isNull(pdadetalhe['atividade'].label)
                                ? 'informacao-cliente-atividade'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['atividade'].altera == 0)
                        "
                        @onBlurFunction="sendIsChanged('atividade')"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="pdadetalhe['ramo'] && !pdadetalhe['ramo'].oculta"
                >
                    <vss-select
                        :id="generateId(42)"
                        ref="ramo"
                        :title="
                            !isNull(pdadetalhe['ramo'].label)
                                ? pdadetalhe['ramo'].label
                                : 'ramo-atuacao'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['ramo'].label)"
                        :msg="pdadetalhe['ramo'].msg"
                        :invalid="pdadetalhe['ramo'].invalid"
                        :required="pdadetalhe['ramo'].obrigainclusao"
                        :clearable="!pdadetalhe['ramo'].obrigainclusao"
                        :searchable="false"
                        :options="ramoSelect"
                        v-model="ramoSelected"
                        :mlLabels="false"
                        :tooltipLabel="
                            isNull(pdadetalhe['ramo'].label)
                                ? 'informacao-cliente-ramo'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['ramo'].altera == 0)
                        "
                        @onBlurFunction="sendIsChanged('ramo')"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="pdadetalhe['matriz'] && !pdadetalhe['matriz'].oculta"
                >
                    <vss-select
                        :id="generateId(43)"
                        ref="matriz"
                        :title="
                            !isNull(pdadetalhe['matriz'].label)
                                ? pdadetalhe['matriz'].label
                                : 'matriz'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['matriz'].label)"
                        :msg="pdadetalhe['matriz'].msg"
                        :invalid="pdadetalhe['matriz'].invalid"
                        :required="pdadetalhe['matriz'].obrigainclusao"
                        :clearable="!pdadetalhe['matriz'].obrigainclusao"
                        :searchable="false"
                        :options="matrizSelect"
                        v-model="matrizSelected"
                        :mlLabels="false"
                        :tooltipLabel="
                            isNull(pdadetalhe['matriz'].label)
                                ? 'informacao-cliente-matriz'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['matriz'].altera == 0)
                        "
                        @onBlurFunction="sendIsChanged('matriz')"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['situacao'] && !pdadetalhe['situacao'].oculta
                    "
                >
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(42)"
                                ref="situacao"
                                :title="
                                    !isNull(pdadetalhe['situacao'].label)
                                        ? pdadetalhe['situacao'].label
                                        : 'situacao-cadastral'
                                "
                                :disableMLtitle="
                                    !isNull(pdadetalhe['situacao'].label)
                                "
                                :msg="pdadetalhe['situacao'].msg"
                                :invalid="pdadetalhe['situacao'].invalid"
                                :required="
                                    pdadetalhe['situacao'].obrigainclusao
                                "
                                :clearable="
                                    !pdadetalhe['situacao'].obrigainclusao
                                "
                                :searchable="false"
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                :mlLabels="false"
                                :tooltipLabel="
                                    isNull(pdadetalhe['situacao'].label)
                                        ? 'informacao-cliente-situacao'
                                        : null
                                "
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :disabled="
                                    cantEdit ||
                                    (isUpdate &&
                                        pdadetalhe['situacao'].altera == 0)
                                "
                                @onBlurFunction="sendIsChanged('situacao')"
                            />
                        </div>
                        <div class="control padding-label padding-label-custom">
                            <b-button
                                @click="showModalCadastroSituacao = true"
                                icon-right="plus"
                                v-tippy 
                                :title="$t('adicionar') +
                                ' ' +
                                $t('situacao-cliente')"
                            />
                        </div>
                    </div>
                    <b-modal :active.sync="showModalCadastroSituacao">
                        <div>
                            <SituacaoCadastroModal
                                v-if="showModalCadastroSituacao"
                                @fecharModal="
                                    fecharModalSituacaoWithValue($event)
                                "
                            />
                        </div>
                    </b-modal>
                </div>
                <!-- @86384 - Mostra os status que podem ser alterados no cliente. -->
                <div class="column is-4"
                    v-if="
                        pdadetalhe['registro_enviado'] && !pdadetalhe['registro_enviado'].oculta && isUpdate
                ">
                    <vss-select
                        :id="generateId(42)"
                        ref="status"
                        :title="'status'"
                        :loading="statusLoading"
                        :required="
                            pdadetalhe['registro_enviado'].obrigainclusao
                        "
                        :clearable="
                            !pdadetalhe['registro_enviado'].obrigainclusao
                        "
                        :invalid="pdadetalhe['registro_enviado'].invalid"
                        :searchable="false"
                        :options="statusSelect"
                        v-model="statusSelected"
                        :disabled="!isEditStatus"
                        :mlLabels="false"
                        :tooltipLabel="'informacao-cliente-status'"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        @onBlurFunction="sendIsChanged('registro_enviado')"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['transportadora'] &&
                        !pdadetalhe['transportadora'].oculta
                    "
                >
                    <vss-select
                        :id="generateId(42)"
                        ref="transportadora"
                        :title="
                            !isNull(pdadetalhe['transportadora'].label)
                                ? pdadetalhe['transportadora'].label
                                : 'transportadora-padrao'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['transportadora'].label)
                        "
                        :msg="pdadetalhe['transportadora'].msg"
                        :invalid="pdadetalhe['transportadora'].invalid"
                        :clearable="
                            !pdadetalhe['transportadora'].obrigainclusao
                        "
                        :required="pdadetalhe['transportadora'].obrigainclusao"
                        :searchable="false"
                        :options="transportadoraSelect"
                        v-model="transportadoraSelected"
                        :mlLabels="false"
                        :tooltipLabel="
                            isNull(pdadetalhe['transportadora'].label)
                                ? 'informacao-cliente-transportadora'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate &&
                                pdadetalhe['transportadora'].altera == 0)
                        "
                        @onBlurFunction="sendIsChanged('transportadora')"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['grupoeconomico'] &&
                        !pdadetalhe['grupoeconomico'].oculta
                    "
                >
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(42)"
                                ref="grupoeconomico"
                                :title="
                                    !isNull(pdadetalhe['grupoeconomico'].label)
                                        ? pdadetalhe['grupoeconomico'].label
                                        : 'grupoeconomico'
                                "
                                :disableMLtitle="
                                    !isNull(pdadetalhe['grupoeconomico'].label)
                                "
                                :msg="pdadetalhe['grupoeconomico'].msg"
                                :invalid="pdadetalhe['grupoeconomico'].invalid"
                                :clearable="
                                    !pdadetalhe['grupoeconomico'].obrigainclusao
                                "
                                :required="
                                    pdadetalhe['grupoeconomico'].obrigainclusao
                                "
                                :searchable="false"
                                :options="grupoeconomicoSelect"
                                v-model="grupoeconomicoSelected"
                                :mlLabels="false"
                                :tooltipLabel="
                                    isNull(pdadetalhe['grupoeconomico'].label)
                                        ? 'informacao-cliente-grupoeconomico'
                                        : null
                                "
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :disabled="
                                    cantEdit ||
                                    (isUpdate &&
                                        pdadetalhe['grupoeconomico'].altera ==
                                            0)
                                "
                                @onBlurFunction="
                                    sendIsChanged('grupoeconomico')
                                "
                            />
                        </div>
                        <div
                            class="control padding-label padding-label-custom"
                            v-if="hasGrupoEconomicoPermission"
                        >
                            <b-button
                                @click="
                                    showModalCadastroGrupoEconomico = true
                                "
                                icon-right="plus"
                                v-tippy 
                                :title="$t('adicionar') +
                                    ' ' +
                                    $t('grupoeconomico')"
                            />
                        </div>
                        <b-modal :active.sync="showModalCadastroGrupoEconomico">
                            <div>
                                <GrupoEconomicoCadastroModal
                                    v-if="showModalCadastroGrupoEconomico"
                                    @fecharModal="fecharModalGrupoEconomico($event)"
                                />
                            </div>
                        </b-modal>
                    </div>
                </div>
                <!-- @84474 - Inserido campo de tipo de consumidor -->
                <div class="column is-4">
                    <vss-select
                        :id="generateId(21)"
                        ref="tipoconsumidor"
                        title="tipo-consumidor"
                        :searchable="false"
                        :options="tipoConsumidorSelect"
                        v-model="tipoConsumidorSelected"
                        :mlLabels="true"
                        tooltipLabel="informacao-cliente-tipoconsumidor"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="cantEdit"
                        @onBlurFunction="sendIsChanged()"
                    />
                </div>
            </div>
            <VerifiedConfigExtra
                v-if="showConfigExtra"
                tabela="cliente"
                :extra="extra"
                :cantEdit="cantEdit"
                :isUpdate="isUpdate"
                :checkValidations="checkValidations"
                @validating="checkValidations = $event"
                @onChange="changeValConfigExtra($event)"
                @hasExtra="hasExtra.geral = $event"
                aba="geral"
            />
        </div>
        <div
            ref="tab-endereco"
            class="tab-endereco page-container form-columns-fit mt-4 mb-4"
            v-if="!conflito.has"
            v-show="hasFields.endereco || hasExtra.endereco"
        >
            <div class="columns is-flex-wrap">
                <!-- start cep --------------------------------------------------------------- -->
                <div
                    class="column is-3"
                    :class="{ loading: isSearchingCEP }"
                    v-if="
                        pdadetalhe['cep'] &&
                        !pdadetalhe['cep'].oculta &&
                        (estrangeiroSelected.id == 0 ||
                            (estrangeiroSelected.id == 1 &&
                                isNull(pdadetalhe['cepestrangeiro'])))
                    "
                >
                    <v-input
                        :id="generateId(100)"
                        :key="generateId(100)"
                        ref="cep"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.cep"
                        :title="
                            !isNull(pdadetalhe['cep'].label)
                                ? pdadetalhe['cep'].label
                                : 'cep-do-cliente'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['cep'].label)"
                        placeholder="cep-do-cliente-placeholder"
                        :msg="pdadetalhe['cep'].msg"
                        :invalid="pdadetalhe['cep'].invalid"
                        :required="pdadetalhe['cep'].obrigainclusao"
                        @onBlurFunction="validadeByPdaDetalhe('cep')"
                        :useMask="true"
                        :vMask="['##.###-###']"
                        :icon="cantEdit ? null : 'magnify'"
                        @input-action="getInfoByCEP"
                        :tooltipLabel="
                            isNull(pdadetalhe['cep'].label)
                                ? 'informacao-cliente-cep'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['cep'].altera == 0)
                        "
                    />
                </div>
                <!-- Quando for estrangeiro, se tiver o campo cepestrangeiro em modulopdadetalhe a apresentação segue o modulopdadetalhe -->
                <div
                    class="column is-3"
                    v-else-if="
                        pdadetalhe['cep'] &&
                        pdadetalhe['cepestrangeiro'] &&
                        !pdadetalhe['cepestrangeiro'].oculta
                    "
                >
                    <v-input
                        :id="generateId(101)"
                        :key="generateId(101)"
                        ref="cepestrangeiro"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.cep"
                        placeholder="cep-do-cliente-placeholder"
                        :title="
                            !isNull(pdadetalhe['cepestrangeiro'].label)
                                ? pdadetalhe['cepestrangeiro'].label
                                : 'cepestrangeiro'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['cepestrangeiro'].label)
                        "
                        :msg="pdadetalhe['cepestrangeiro'].msg"
                        :invalid="pdadetalhe['cepestrangeiro'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('cepestrangeiro')"
                        :required="pdadetalhe['cepestrangeiro'].obrigainclusao"
                        :disabled="
                            cantEdit ||
                            (isUpdate &&
                                pdadetalhe['cepestrangeiro'].altera == 0)
                        "
                        :validchars="pdadetalhe['cepestrangeiro'].validchars"
                        :maxlength="
                            pdadetalhe['cepestrangeiro'].maxlength > 0
                                ? pdadetalhe['cepestrangeiro'].maxlength
                                : 10
                        "
                        :tooltipLabel="
                            isNull(pdadetalhe['cepestrangeiro'].label)
                                ? 'informacao-cliente-cepestrangeiro'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                    />
                </div>
                <!-- end cep ----------------------------------------------------------------- -->
                <div
                    class="column is-4"
                    v-if="pdadetalhe['cidade'] && !pdadetalhe['cidade'].oculta"
                >
                    <vss-select
                        :id="generateId(110)"
                        ref="cidade"
                        label="nome"
                        v-model="cidadeSelected"
                        placeholder="selecione"
                        :title="
                            !isNull(pdadetalhe['cidade'].label)
                                ? pdadetalhe['cidade'].label
                                : 'cidade'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['cidade'].label)"
                        :options="cidadeSelect"
                        :msg="pdadetalhe['cidade'].msg"
                        :invalid="pdadetalhe['cidade'].invalid"
                        searchable
                        @search="loadCidade"
                        :required="pdadetalhe['cidade'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['cidade'].label)
                                ? 'informacao-cliente-cidade'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['cidade'].altera == 0)
                        "
                        @onBlurFunction="sendIsChanged('cidade'), updateCidade()"
                    />
                </div>
                <div
                    class="column is-5"
                    v-if="pdadetalhe['bairro'] && !pdadetalhe['bairro'].oculta"
                >
                    <v-input
                        :id="generateId(120)"
                        ref="bairro"
                        v-model="cliente.bairro"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['bairro'].label)
                                ? pdadetalhe['bairro'].label
                                : 'bairro'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['bairro'].label)"
                        :msg="pdadetalhe['bairro'].msg"
                        :invalid="pdadetalhe['bairro'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('bairro')"
                        :required="pdadetalhe['bairro'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['bairro'].label)
                                ? 'informacao-cliente-bairro'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['bairro'].altera == 0)
                        "
                        :validchars="pdadetalhe['bairro'].validchars"
                        :maxlength="
                            pdadetalhe['bairro'].maxlength > 0
                                ? pdadetalhe['bairro'].maxlength
                                : 50
                        "
                    />
                </div>
                <div
                    class="column is-9"
                    v-if="
                        pdadetalhe['endereco'] && !pdadetalhe['endereco'].oculta
                    "
                >
                    <v-input
                        :id="generateId(130)"
                        ref="endereco"
                        v-model="cliente.endereco"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['endereco'].label)
                                ? pdadetalhe['endereco'].label
                                : 'endereco'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['endereco'].label)"
                        :msg="pdadetalhe['endereco'].msg"
                        :invalid="pdadetalhe['endereco'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('endereco')"
                        :required="pdadetalhe['endereco'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['endereco'].label)
                                ? 'informacao-cliente-endereco'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['endereco'].altera == 0)
                        "
                        :validchars="pdadetalhe['endereco'].validchars"
                        :maxlength="
                            pdadetalhe['endereco'].maxlength > 0
                                ? pdadetalhe['endereco'].maxlength
                                : 50
                        "
                    />
                </div>
                <div
                    class="column is-3"
                    v-if="pdadetalhe['numero'] && !pdadetalhe['numero'].oculta"
                >
                    <v-input
                        :id="generateId(140)"
                        ref="numero"
                        v-model="cliente.numero"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['numero'].label)
                                ? pdadetalhe['numero'].label
                                : 'numero'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['numero'].label)"
                        :msg="pdadetalhe['numero'].msg"
                        :invalid="pdadetalhe['numero'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('numero')"
                        :required="pdadetalhe['numero'].obrigainclusao"
                        :useMask="
                            isNull(pdadetalhe['numero'].validchars) ||
                            (!isNull(pdadetalhe['numero'].validchars) &&
                                onlyNumbers(pdadetalhe['numero'].validchars))
                        "
                        :vMask="['##########']"
                        :tooltipLabel="
                            isNull(pdadetalhe['numero'].label)
                                ? 'informacao-cliente-numero'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['numero'].altera == 0)
                        "
                        :validchars="pdadetalhe['numero'].validchars"
                        :maxlength="
                            pdadetalhe['numero'].maxlength > 0
                                ? pdadetalhe['numero'].maxlength
                                : 15
                        "
                    />
                </div>
                <div
                    class="column is-12"
                    v-if="
                        pdadetalhe['complemento'] &&
                        !pdadetalhe['complemento'].oculta
                    "
                >
                    <v-input
                        :id="generateId(141)"
                        ref="complemento"
                        v-model="cliente.complemento"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['complemento'].label)
                                ? pdadetalhe['complemento'].label
                                : 'complemento'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['complemento'].label)
                        "
                        :msg="pdadetalhe['complemento'].msg"
                        :invalid="pdadetalhe['complemento'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('complemento')"
                        :required="pdadetalhe['complemento'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['complemento'].label)
                                ? 'informacao-cliente-complemento'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['complemento'].altera == 0)
                        "
                        :validchars="pdadetalhe['complemento'].validchars"
                        :maxlength="
                            pdadetalhe['complemento'].maxlength > 0
                                ? pdadetalhe['complemento'].maxlength
                                : 50
                        "
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        pdadetalhe['latitude'] && !pdadetalhe['latitude'].oculta
                    "
                >
                    <v-input
                        :id="generateId(150)"
                        ref="latitude"
                        v-model="cliente.latitude"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['latitude'].label)
                                ? pdadetalhe['latitude'].label
                                : 'latitude'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['latitude'].label)"
                        :msg="pdadetalhe['latitude'].msg"
                        :invalid="pdadetalhe['latitude'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('latitude')"
                        :required="pdadetalhe['latitude'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['latitude'].label)
                                ? 'informacao-cliente-latitude'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['latitude'].altera == 0)
                        "
                        :maxlength="50"
                        validchars="0123456789-."
                    />
                </div>
                <div
                    class="column"
                    :class="[
                        windowWidth > 920 ? 'is-4'
                        : 'is-6'
                    ]"
                    v-if="
                        pdadetalhe['longitude'] &&
                        !pdadetalhe['longitude'].oculta
                    "
                >
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <v-input
                                :id="generateId(160)"
                                ref="longitude"
                                v-model="cliente.longitude"
                                placeholder="placeholder-preencha"
                                :title="
                                    !isNull(pdadetalhe['longitude'].label)
                                        ? pdadetalhe['longitude'].label
                                        : 'longitude'
                                "
                                :disableMLtitle="
                                    !isNull(pdadetalhe['longitude'].label)
                                "
                                :msg="pdadetalhe['longitude'].msg"
                                :invalid="pdadetalhe['longitude'].invalid"
                                @onBlurFunction="
                                    validadeByPdaDetalhe('longitude')
                                "
                                :required="
                                    pdadetalhe['longitude'].obrigainclusao
                                "
                                :tooltipLabel="
                                    isNull(pdadetalhe['longitude'].label)
                                        ? 'informacao-cliente-longitude'
                                        : null
                                "
                                tooltipSize="is-small"
                                tooltipPosition="is-top"
                                :disabled="
                                    cantEdit ||
                                    (isUpdate &&
                                        pdadetalhe['longitude'].altera == 0)
                                "
                                :maxlength="50"
                                validchars="0123456789-."
                            />
                        </div>
                        <div v-if="!cantEdit && windowWidth <= 920"
                            class="control padding-label padding-label-custom">
                            <b-button 
                                @click="openLocationEditor" 
                                icon-right="map-marker" 
                                type="is-primary"
                                v-tippy 
                                :title="$t('pesquisar-localizacao')"
                            />
                        </div>
                    </div>
                </div>
                <div
                    class="column is-2"
                    v-if="this.windowWidth > 920 && !cantEdit"
                >
                    <button
                        class="save-btn botao-localizacao"
                        type="button"
                        @click="openLocationEditor"
                    >
                        {{ $t("pesquisar-localizacao") }}
                    </button>
                </div>
            </div>
            <VerifiedConfigExtra
                v-if="showConfigExtra"
                tabela="cliente"
                :extra="extra"
                :cantEdit="cantEdit"
                :isUpdate="isUpdate"
                :checkValidations="checkValidations"
                @validating="checkValidations = $event"
                @onChange="changeValConfigExtra($event)"
                @hasExtra="hasExtra.endereco = $event"
                aba="endereco"
            />
        </div>
        <div
            ref="tab-contato"
            class="tab-contato page-container form-columns-fit mt-4 mb-4"
            v-if="!conflito.has"
            v-show="hasFields.contato"
        >
            <div class="columns is-flex-wrap">
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['telefone'] && !pdadetalhe['telefone'].oculta
                    "
                >
                    <v-input-tel
                        :id="generateId(170)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="telefone"
                        v-model="cliente.telefone"
                        :title="
                            !isNull(pdadetalhe['telefone'].label)
                                ? pdadetalhe['telefone'].label
                                : 'telefone'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['telefone'].label)"
                        :msg="pdadetalhe['telefone'].msg"
                        :invalid="pdadetalhe['telefone'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('telefone')"
                        :required="pdadetalhe['telefone'].obrigainclusao"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['telefone'].altera == 0)
                        "
                        :edit="inputTelefoneEdit"
                        :tooltipLabel="
                            isNull(pdadetalhe['telefone'].label)
                                ? 'informacao-cliente-telefone'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :maxlength="20"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="
                        pdadetalhe['celular'] && !pdadetalhe['celular'].oculta
                    "
                >
                    <v-input-tel
                        v-if="!copyToCelularActive"
                        :id="generateId(180)"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        ref="celular"
                        v-model="cliente.celular"
                        :title="
                            !isNull(pdadetalhe['celular'].label)
                                ? pdadetalhe['celular'].label
                                : 'celular'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['celular'].label)"
                        :msg="pdadetalhe['celular'].msg"
                        :invalid="pdadetalhe['celular'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('celular')"
                        :required="pdadetalhe['celular'].obrigainclusao"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['celular'].altera == 0)
                        "
                        :edit="inputCelularEdit"
                        :icon="cantEdit ? null : 'content-copy'"
                        @input-action="copyToWhatsApp"
                        :iconTooltip="'copiar-tel-para-o-campo-wpp'"
                        :tooltipLabel="
                            isNull(pdadetalhe['celular'].label)
                                ? 'informacao-cliente-celular'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :maxlength="20"
                    />
                </div>
                <div
                    class="column is-4"
                    v-if="pdadetalhe['fax'] && !pdadetalhe['fax'].oculta"
                >
                    <v-input-tel
                        v-if="!copyToWhatsAppActive"
                        :id="generateId(190)"
                        ref="fax"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.fax"
                        :title="
                            !isNull(pdadetalhe['fax'].label)
                                ? pdadetalhe['fax'].label
                                : 'fax-do-cliente'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['fax'].label)"
                        :edit="inputFaxEdit"
                        :msg="pdadetalhe['fax'].msg"
                        :invalid="pdadetalhe['fax'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('fax')"
                        :required="pdadetalhe['fax'].obrigainclusao"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['fax'].altera == 0)
                        "
                        :tooltipLabel="
                            isNull(pdadetalhe['fax'].label)
                                ? 'informacao-cliente-fax'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :maxlength="20"
                    />
                    <v-input v-else disabled title="fax-do-cliente" />
                </div>
                <div
                    class="column is-6"
                    v-if="pdadetalhe['email'] && !pdadetalhe['email'].oculta"
                >
                    <v-input
                        :id="generateId(200)"
                        ref="email"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.email"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['email'].label)
                                ? pdadetalhe['email'].label
                                : 'email'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['email'].label)"
                        :msg="pdadetalhe['email'].msg"
                        :invalid="pdadetalhe['email'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('email')"
                        :required="pdadetalhe['email'].obrigainclusao"
                        :icon="cantEdit ? null : 'content-copy'"
                        :iconTooltip="'copiar-email-para-o-campo-email-NFE'"
                        @input-action="copyEmail"
                        type="email"
                        :tooltipLabel="
                            isNull(pdadetalhe['email'].label)
                                ? 'informacao-cliente-email'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['email'].altera == 0)
                        "
                        :validchars="pdadetalhe['email'].validchars"
                        :maxlength="
                            pdadetalhe['email'].maxlength > 0
                                ? pdadetalhe['email'].maxlength
                                : 50
                        "
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        pdadetalhe['emailnfe'] && !pdadetalhe['emailnfe'].oculta
                    "
                >
                    <v-input
                        :id="generateId(210)"
                        ref="emailnfe"
                        :hideInfo="hide.hideInfo"
                        :infoIsHidden="hide.infoIsHidden"
                        v-model="cliente.emailnfe"
                        placeholder="placeholder-preencha"
                        :title="
                            !isNull(pdadetalhe['emailnfe'].label)
                                ? pdadetalhe['emailnfe'].label
                                : 'email-nfe'
                        "
                        :disableMLtitle="!isNull(pdadetalhe['emailnfe'].label)"
                        :msg="pdadetalhe['emailnfe'].msg"
                        :invalid="pdadetalhe['emailnfe'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('emailnfe')"
                        :required="pdadetalhe['emailnfe'].obrigainclusao"
                        type="email"
                        :tooltipLabel="
                            isNull(pdadetalhe['emailnfe'].label)
                                ? 'informacao-cliente-emailnfe'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['emailnfe'].altera == 0)
                        "
                        :validchars="pdadetalhe['emailnfe'].validchars"
                        :maxlength="
                            pdadetalhe['emailnfe'].maxlength > 0
                                ? pdadetalhe['emailnfe'].maxlength
                                : 50
                        "
                    />
                </div>
            </div>
        </div>
        <div
            ref="tab-obs"
            class="tab-obs page-container sem-margem-bottom mt-4 mb-4"
            v-if="!conflito.has"
            v-show="hasFields.obs || hasExtra.obs"
        >
            <div class="columns is-flex-wrap">
                <div
                    class="column is-6"
                    v-if="
                        pdadetalhe['obscadastral'] &&
                        !pdadetalhe['obscadastral'].oculta
                    "
                >
                    <v-textarea
                        ref="obscadastral"
                        :id="generateId(220)"
                        v-model="cliente.obscadastral"
                        :title="
                            !isNull(pdadetalhe['obscadastral'].label)
                                ? pdadetalhe['obscadastral'].label
                                : 'obscadastral'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['obscadastral'].label)
                        "
                        :msg="pdadetalhe['obscadastral'].msg"
                        placeholder="placeholder-preencha"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        :invalid="pdadetalhe['obscadastral'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('obscadastral')"
                        :required="pdadetalhe['obscadastral'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['obscadastral'].label)
                                ? 'informacao-cliente-obscadastral'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate && pdadetalhe['obscadastral'].altera == 0)
                        "
                        :validchars="pdadetalhe['obscadastral'].validchars"
                        :maxlength="
                            pdadetalhe['obscadastral'].maxlength > 0
                                ? pdadetalhe['obscadastral'].maxlength
                                : 1000
                        "
                    />
                </div>
                <div
                    class="column is-6"
                    v-if="
                        pdadetalhe['obsfinanceira'] &&
                        !pdadetalhe['obsfinanceira'].oculta
                    "
                >
                    <v-textarea
                        ref="obsfinanceira"
                        :id="generateId(220)"
                        v-model="cliente.obsfinanceira"
                        :title="
                            !isNull(pdadetalhe['obsfinanceira'].label)
                                ? pdadetalhe['obsfinanceira'].label
                                : 'obsfinanceira'
                        "
                        :disableMLtitle="
                            !isNull(pdadetalhe['obsfinanceira'].label)
                        "
                        :msg="pdadetalhe['obsfinanceira'].msg"
                        placeholder="placeholder-preencha"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        :invalid="pdadetalhe['obsfinanceira'].invalid"
                        @onBlurFunction="validadeByPdaDetalhe('obsfinanceira')"
                        :required="pdadetalhe['obsfinanceira'].obrigainclusao"
                        :tooltipLabel="
                            isNull(pdadetalhe['obsfinanceira'].label)
                                ? 'informacao-cliente-obsfinanceira'
                                : null
                        "
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="
                            cantEdit ||
                            (isUpdate &&
                                pdadetalhe['obsfinanceira'].altera == 0)
                        "
                        :validchars="pdadetalhe['obsfinanceira'].validchars"
                        :maxlength="
                            pdadetalhe['obsfinanceira'].maxlength > 0
                                ? pdadetalhe['obsfinanceira'].maxlength
                                : 1000
                        "
                    />
                </div>
            </div>
            <VerifiedConfigExtra
                ref="tab-extra"
                v-if="showConfigExtra"
                tabela="cliente"
                :extra="extra"
                :cantEdit="cantEdit"
                :isUpdate="isUpdate"
                :checkValidations="checkValidations"
                @validating="checkValidations = $event"
                @onChange="changeValConfigExtra($event)"
                @hasExtra="hasExtra.obs = $event"
                aba="obs"
            />
        </div>

        <MapasGoogleMapsModal
            v-if="permissao.update && startedMaps"
            :center="center"
            :isUpdating="isSaving"
            :locationEditorOpen="locationEditorOpen"
            :update="isUpdate"
            label="selecionar"
            @updateLocation="updateLocation"
            @onCancelLocationEditor="onCancelLocationEditor"
            :startSearchWith="startSearchWith"
        />
    </div>
</template>

<script>
import ClienteService from "@/services/vendas/cliente/ClienteService";
import CidadeService from "@/services/CidadeService";
import SituacaoService from "@/services/SituacaoService";
import RegiaoService from "@/services/RegiaoService";
import AtividadeService from "@/services/AtividadeService";
import RamoService from "@/services/RamoService";
import TransportadoraService from "@/services/vendas/TransportadoraService";
import GrupoEconomicoService from "@/services/agro/GrupoEconomicoService";
import HideInfo from "@/components/shared/HideInfo";
import Message from "@/models/Message";
import { TheMask } from "vue-the-mask";
import * as InscricaoEstadual from "@/functions/IEValidation.js";
import { mapState } from "vuex";
import MapasGoogleMapsModal from "@/components/shared/maps/MapasGoogleMapsModal";
// tabela: CONFIGEXTRA - chamado #71054
import VerifiedConfigExtra from "@/components/shared/form/VerifiedConfigExtra";
import CidadeModal from "@/components/vendas/cliente/modal/CidadeModal";
import RegiaoCadastroModal from "@/components/vendas/cliente/modal/RegiaoCadastroModal.vue";
import SituacaoCadastroModal from "@/components/vendas/cliente/modal/SituacaoCadastroModal.vue";
import GrupoEconomicoCadastroModal from "@/components/agro/grupoeconomico/modal/GrupoEconomicoCadastroModal.vue";

export default {
    components: {
        TheMask,
        HideInfo,
        MapasGoogleMapsModal,
        CidadeModal,
        VerifiedConfigExtra,
        RegiaoCadastroModal,
        SituacaoCadastroModal,
        GrupoEconomicoCadastroModal,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        idFrom: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            usuarioIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("CLIENTE"),
            service: new ClienteService(this.$http, this.$router),
            cidadeService: new CidadeService(this.$http, this.$router),
            situacaoService: new SituacaoService(this.$http, this.$router),
            regiaoService: new RegiaoService(this.$http, this.$router),
            atividadeService: new AtividadeService(this.$http, this.$router),
            ramoService: new RamoService(this.$http, this.$router),
            serviceTransportadora: new TransportadoraService(
                this.$http,
                this.$router
            ),
            serviceGrupoEconomico: new GrupoEconomicoService(
                this.$http,
                this.$router
            ),

            msgs: [],

            isLoading: false,
            isSaving: false,
            permissao: false,

            isSearchingCNPJ: false,
            isSearchingCEP: false,

            inputFaxEdit: false,
            inputCelularEdit: false,
            inputTelefoneEdit: false,

            // dados para comparação em obrigaalteracao
            clienteOld: null,
            cliente: {
                idcliente: null,
                idclienteerp: null, // not null
                idcidade: null, // not null
                idatividade: null, // not null
                idramo: null, // not null
                idregiao: null, // not null
                idsituacao: null, // not null
                idmatriz: null, // not null
                idtransportadora: null,
                idgrupoeconomico: null,
                coeftabpreco: 0, // not null
                nome: null, // not null
                rsocial: null, // not null
                endereco: null,
                numero: null,
                bairro: null,
                cep: null,
                ierg: null,
                cnpjcpf: null, // not null
                telefone: null,
                fax: null,
                celular: null,
                email: null,
                emailnfe: null,
                datanascimento: null,
                obscadastral: null,
                obsfinanceira: null,
                extra1: null,
                extra2: null,
                extra3: null,
                latitude: null,
                longitude: null,
                complemento: null,
                estrangeiro: null,
                tipocliente: null,
                contribuinte: null,
                tipoconsumidor: null,
                registro_enviado: null,
            },
            datanascimento: null,
            // campos com código campo em pdadetalhe direfente da chave da coluna
            tests: [
                "regiao",
                "atividade",
                "ramo",
                "matriz",
                "situacao",
                "cidade",
                "transportadora",
                "grupoeconomico",
            ],
            // campos dligados a tabela configextra
            extra: {
                extra1: {
                    value: null,
                    obgInc: false,
                    obgAlt: false,
                    validated: true,
                    msg: null,
                },
                extra2: {
                    value: null,
                    obgInc: false,
                    obgAlt: false,
                    validated: true,
                    msg: null,
                },
                extra3: {
                    value: null,
                    obgInc: false,
                    obgAlt: false,
                    validated: true,
                    msg: null,
                },
            },
            // validação para exibição de tabs
            hasFields: {
                geral: true,
                endereco: true,
                contato: true,
                obs: true,
            },
            hasExtra: {
                geral: true,
                endereco: true,
                obs: true,
            },

            copyToWhatsAppActive: false,
            copyToCelularActive: false,
            center: { lat: 0, lng: 0 },
            locationEditorOpen: false,
            buscaCep: null,
            startSearchWith: "",
            cantEdit: false,
            startedMaps: false,
            pdadetalhe: {},
            pdadetalheHasData: false,
            firstEntry: true,
            cidadeSelect: [],
            cidadeSelected: null,
            regiaoSelect: [],
            regiaoSelected: null,
            situacaoSelect: [],
            situacaoSelected: null,
            statusSelect: [],
            statusSelected: null,
            atividadeSelect: [],
            atividadeSelected: null,
            ramoSelect: [],
            ramoSelected: null,
            matrizSelect: [],
            matrizSelected: null,
            transportadoraSelect: [],
            transportadoraSelected: null,
            grupoeconomicoSelect: [],
            grupoeconomicoSelected: null,
            hasGrupoEconomicoPermission: true,

            pessoaSelect: [
                { label: "pessoa-juridica", id: 1 },
                { label: "pessoa-fisica", id: 0 },
            ],
            estrangeiroSelect: [
                { label: "nao", id: 0 },
                { label: "sim", id: 1 },
            ],
            contribuinteSelect: [
                { label: "contribuinte-icms", id: "C" },
                { label: "contribuinte-isento", id: "I" },
                { label: "contribuinte-nao", id: "N" },
            ],
            tipoConsumidorSelect: [
                { label: "consumidor-final", id: 1 },
                { label: "consumidor-normal", id: 0 },
            ],
            pessoaSelected: { label: "pessoa-juridica", id: 1 },
            tipoConsumidorSelected: { label: "consumidor-normal", id: 0 },
            estrangeiroSelected: { label: "nao", id: 0 },
            contribuinteSelected: { label: "contribuinte-nao", id: "N" },
            // esconde config extra até ter dados no edit
            showConfigExtra: false,
            checkValidations: false,
            // passa função do útil para o componente
            
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            startedData: false,
            // regra para exibissão de conflito entre as configs do modulopdadetalhe e o banco de dados
            conflito: {
                has: false,
                config: false,
                oculto: false,
            },
            conflitoFieldConfig: "",
            conflitoFieldOculto: "",

            // Modal de cadastro de região
            showModalCadastroSituacao: false,
            showModalCadastroRegiao: false,
            showModalCadastroGrupoEconomico: false,

            statusLoading: false,
            isEditStatus: false,
            statusPermiteEdit: ["N", "AP", "F", "A", "C", "EI"],

            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    computed: {
        ...mapState(["hide"]),
    },
    watch: {
        cliente: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit("isChanged", true);
                } 
            },
        },
        pessoaSelected: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.cleanFieldsWhenChangeTipes();
                }
            },
        },
        estrangeiroSelected: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.cleanFieldsWhenChangeTipes();
                }
            },
        },
        contribuinteSelected: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.changeContribuinte();
                }
            },
        },
    },
    created() {
        setTimeout(() => {
            this.$emit("isChanged", false);
        }, 500);
    
        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas', 
                'clientes', 
                'ven-cliente-dados-cadastrais-geral')
        }else if(this.isAgro){
            this.permissao = this.hasPermissionAccess(
                'agro', 
                'clientes', 
                'agro-cliente-dados-cadastrais-geral');
        }

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "clientes" },
            });
        } else {
            this.showConfigExtra = !this.isUpdate;

            this.getModulo("CLIENTE").detalhe.forEach((d) => {
                d.invalid = false;
                d.msg = "msg-campo-obrigatorio";
                this.$set(this.pdadetalhe, d.campo.toLowerCase(), d);
                // Caso tenha dados em pdadetalhe
                this.pdadetalheHasData = true;
            });

            let grupoeconomicoPermissoes = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "cli-grupoeconomico"
            );
            this.hasGrupoEconomicoPermission = grupoeconomicoPermissoes.create;

            /* validação por campos não nulos na tabela cliente;
            Caso um destes campos não estejam configurados corretamente, 
            avisar para ajustar o modulopdadetalhe no mobileManager */
            // , "rsocial"
            let fields = ["nome", "cnpjcpf"];
            fields.forEach((field) => {
                this.checkInvalidConfig(field);
            });

            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            } else {
                this.startedMaps = true;
                // carrega infos dos selects
                this.loadRegiao();
                this.loadRamo();
                this.loadSituacao();
                this.loadMatriz();
                this.loadTransportadora();
                this.loadGrupoEconomico();
                // Seguindo regra do mobile, se obrigatório o valor inicial deve ser 1
                if (
                    this.pdadetalhe["coeftabpreco"] &&
                    this.pdadetalhe["coeftabpreco"].obrigainclusao
                ) {
                    this.cliente.coeftabpreco = 1;
                }
            }
            if (this.usuarioIntegracao) this.cantEdit = true;
        }
    },
    mounted() {
        this.hasFields.geral =
            this.$refs["tab-geral"].firstChild.children.length > 0;
        this.hasFields.endereco =
            this.$refs["tab-endereco"].firstChild.children.length > 0;
        this.hasFields.contato =
            this.$refs["tab-contato"].firstChild.children.length > 0;
        this.hasFields.obs =
            this.$refs["tab-obs"].firstChild.children.length > 0;

        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        });
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        generateId(numberId) {
            return this.$route.name + "-geral-" + numberId;
        },
        checkInvalidConfig(field) {
            if (!this.pdadetalhe[field]) {
                this.conflitoFieldConfig += " *" + this.$t(field);
                this.conflito.has = true;
                this.conflito.config = true;
            }
            if (this.pdadetalhe[field] && this.pdadetalhe[field].oculta) {
                this.conflitoFieldOculto += " *" + this.$t(field);
                this.conflito.has = true;
                this.conflito.oculto = true;
            }
            if (this.conflito.has) this.cantEdit = this.conflito.has;
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) {
                this.$emit("isChanged", true);
            }
            // Já aproveita e faz a validação do pdadetalhe
            setTimeout(() => {
                if (label != null) this.validadeByPdaDetalhe(label);
            }, 200);
        },
        changeValConfigExtra(tempExtra) {
            if (!this.isLoadingEdit) {
                this.$emit("isChanged", true);
            }
            Object.entries(tempExtra).forEach(([key, value]) => {
                this.extra[key].validated = value.validated;
                this.extra[key].value = value.value;
            });
        },
        cleanFieldsWhenChangeTipes() {
            if (!this.isLoadingEdit) {
                this.cliente.cnpjcpf = null;
                if (
                    this.pessoaSelected.id == 1 &&
                    this.estrangeiroSelected.id == 0
                ) {
                    this.contribuinteSelected = this.contribuinteSelect[0];
                }
                if (this.pdadetalhe['cnpjcpf']) {
                    this.pdadetalhe['cnpjcpf'].invalid = false;
                    setTimeout(() => {
                        this.$refs.cnpjcpf.focusedOut = true;
                    }, 100);
                }

                if (this.estrangeiroSelected.id == 0) {
                    this.cliente.ierg = null;
                    if (this.pdadetalhe['ierg']) {
                        this.pdadetalhe['ierg'].invalid = false;
                        setTimeout(() => {
                            this.$refs.ierg.focusedOut = true;
                        }, 100);
                    }
                }
            }
        },
        changeContribuinte() {
            if (
                this.pessoaSelected.id == 1 &&
                this.estrangeiroSelected.id == 0
            ) {
                if (this.contribuinteSelected && this.contribuinteSelected.id == "I") {
                    // caso passe para isento seta o valor isento
                    this.cliente.ierg = "ISENTO";
                } else if (this.cliente.ierg == "ISENTO") {
                    // caso venha de isento seta o valor para null, caso contrario mantém a IE
                    this.cliente.ierg = null;
                }
                this.validadeByPdaDetalhe("ierg");
            }
        },
        validadeByPdaDetalhe(field) {
            //manda valores dos objetos internos para o objeto de cliete
            this.sendValuesToCliente(field);
            // limpa a validação para iniciar os testes
            this.pdadetalhe[field].invalid = false;

            setTimeout(() => {
                if (this.customValidations(field)) {
                    // valida campos com validações adicionais
                    return this.pdadetalhe[field].invalid;
                } else if (this.obrigaAlteracao(field)) {
                    // validação pelo pdadetalhe
                    return this.pdadetalhe[field].invalid;
                } else if (this.obrigaInclusao(field)) {
                    // valida por obrigainclusao
                    return this.pdadetalhe[field].invalid;
                }

                return this.pdadetalhe[field].invalid;
            }, 100);
        },
        sendValuesToCliente(field) {
            if (field == "datanascimento") {
                this.cliente.datanascimento =
                    this.datanascimento != null &&
                    this.$moment(this.datanascimento).isValid()
                        ? this.$moment(this.datanascimento).format("YYYY-MM-DD")
                        : null;
            } else if (field == "registro_enviado") {
                this.cliente.registro_enviado =
                    this.statusSelected != null
                        ? this.statusSelected.id
                        : null;
            } else if (field == "regiao") {
                this.cliente.idregiao =
                    this.regiaoSelected != null ? this.regiaoSelected.id : null;
            } else if (field == "atividade") {
                this.cliente.idatividade =
                    this.atividadeSelected != null
                        ? this.atividadeSelected.id
                        : null;
            } else if (field == "ramo") {
                this.cliente.idramo =
                    this.ramoSelected != null ? this.ramoSelected.id : null;
            } else if (field == "situacao") {
                this.cliente.idsituacao =
                    this.situacaoSelected != null
                        ? this.situacaoSelected.id
                        : null;
            } else if (field == "matriz") {
                this.cliente.idmatriz =
                    this.matrizSelected != null ? this.matrizSelected.id : null;
            } else if (field == "transportadora") {
                this.cliente.idtransportadora =
                    this.transportadoraSelected != null
                        ? this.transportadoraSelected.id
                        : null;
            } else if (field == "grupoeconomico") {
                this.cliente.idgrupoeconomico =
                    this.grupoeconomicoSelected != null
                        ? this.grupoeconomicoSelected.id
                        : null;
            } else if (field == "tipoconsumidor") {
                this.cliente.tipoconsumidor =
                    this.tipoConsumidorSelected != null
                        ? this.tipoConsumidorSelected.id
                        : 0;
            } else if (field == "cidade") {
                this.cliente.idcidade =
                    this.cidadeSelected != null ? this.cidadeSelected.id : null;
            }
        },
        customValidations(field) {
            if (field == "cnpjcpf") {
                if (
                    this.pessoaSelected.id == 1 &&
                    this.estrangeiroSelected.id == 0 &&
                    !this.isNull(this.cliente[field]) &&
                    !this.validateCnpj(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
                if (
                    this.pessoaSelected.id == 0 &&
                    this.estrangeiroSelected.id == 0 &&
                    !this.isNull(this.cliente[field]) &&
                    !this.validateCPF(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "cep") {
                if (
                    !this.isNull(this.cliente[field]) &&
                    !this.validateCEP(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "celular") {
                if (
                    !this.isNull(this.cliente[field]) &&
                    this.estrangeiroSelected.id == 0 &&
                    !this.validatePhone(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "fax") {
                if (
                    !this.isNull(this.cliente[field]) &&
                    this.estrangeiroSelected.id == 0 &&
                    (!this.validatePhone(this.cliente[field]) && !this.validatePhone(this.cliente[field]))
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "telefone") {
                if (
                    !this.isNull(this.cliente[field]) &&
                    this.estrangeiroSelected.id == 0 &&
                    !this.validatePhone(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "ierg") {
                if (
                    this.pessoaSelected.id == 0 &&
                    this.estrangeiroSelected.id == 0 &&
                    !this.isNull(this.cliente[field]) &&
                    !this.validateRG(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
                if (
                    this.pessoaSelected.id == 1 &&
                    this.estrangeiroSelected.id == 0 &&
                    this.contribuinteSelected && 
                    this.contribuinteSelected.id != "I" &&
                    !this.isNull(this.cliente[field]) &&
                    !this.validateIE()
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "latitude") {
                if (
                    !this.isNull(this.cliente[field]) &&
                    !this.validateLatitude(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "longitude") {
                if (
                    !this.isNull(this.cliente[field]) &&
                    !this.validateLongitude(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } else if (field == "email" || field == "emailnfe") {
                if (
                    !this.isNull(this.cliente[field]) &&
                    !this.validateEmail(this.cliente[field])
                ) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-campo-invalido";
                }
            } 
            return this.pdadetalhe[field].invalid;
        },
        validateIE() {
            if (this.cidadeSelected == null && !this.isNull(this.cliente.ierg)) {
                /*
                    @85324 - É necessário que o estado (UF) seja reconhecido a partir da cidade para verificar a validade da inscrição estadual 
                    Não foi escolhido verificar o estado a partir da máscara, pois a máscara não é padronizada para diferentes estados
                */
                this.msgs.push(
                    new Message(
                        "alert",
                        "msg-problema-preencher-cidade-cliente",
                        true
                    )
                );
            } else if (!this.isNull(this.cliente.ierg)) {
                let temp = InscricaoEstadual.validateIE(
                    this.cliente.ierg,
                    this.cidadeSelected.estado
                );
                return temp;
            }else{
                return false;
            }
        },
        obrigaAlteracao(field) {
            if (this.isUpdate && this.pdadetalhe[field].obrigaalteracao) {
                // faz ajustes para campos com código campo em pdadetalhe direfente da chave da coluna
                let fieldCliente = this.tests.includes(field)
                    ? "id" + field
                    : field;

                // Só faz toUpperCase se for texto
                let oldValue = this.clienteOld[fieldCliente];
                oldValue =
                    !this.isNull(oldValue) ||
                    (!this.isNull(oldValue) && !this.onlyNumbers(oldValue))
                        ? oldValue.toString().toUpperCase()
                        : oldValue;
                let newValue = this.cliente[fieldCliente];

                let fieldsToClean = ["cnpjcpf", "cep"];
                let fieldsToCleanTel = ["telefone", "fax", "celular"];
                if (
                    fieldsToClean
                        .concat(fieldsToCleanTel)
                        .includes(fieldCliente)
                ) {
                    if (fieldsToCleanTel.includes(fieldCliente)) {
                        let oldValueSplit = oldValue.split(" ");
                        let newValueSplit = newValue.split(" ");

                        if (!(oldValueSplit[0] && oldValueSplit[0].length == 2))
                            oldValue = "BR" + oldValue;
                        if (!(newValueSplit[0] && newValueSplit[0].length == 2))
                            newValue = "BR" + newValue;
                    }

                    oldValue = oldValue.replace(/[^a-zA-Z0-9]/g, "");
                    newValue = newValue.replace(/[^a-zA-Z0-9]/g, "");
                }

                newValue =
                    !this.isNull(newValue) ||
                    (!this.isNull(newValue) && !this.onlyNumbers(newValue))
                        ? newValue.toString().toUpperCase()
                        : newValue;

                if (oldValue == newValue) {
                    this.pdadetalhe[field].invalid = true;
                    this.pdadetalhe[field].msg = "msg-obriga-alteracao";
                }
            }
            return this.pdadetalhe[field].invalid;
        },
        obrigaInclusao(field) {
            if (field == "ierg" && this.estrangeiroSelected.id == 1) {
                this.pdadetalhe[field].invalid = false;
                return this.pdadetalhe[field].invalid;
            }

            // faz ajustes para campos com código campo em pdadetalhe direfente da chave da coluna
            let fieldCliente = this.tests.includes(field)
                ? "id" + field
                : field;

            if (fieldCliente == "cepestrangeiro") {
                fieldCliente = "cep";
            }

            if (
                // field == "campo obrigatório sobrepondo regra da pdadetalhe" 
                (this.pdadetalhe[field].obrigainclusao 
                    || field == "cnpjcpf" 
                    || field == "nome" 
                    // || field == "rsocial"
                    ) &&
                this.isNull(this.cliente[fieldCliente])
            ) {
                this.pdadetalhe[field].invalid = true;
                this.pdadetalhe[field].msg = "msg-campo-obrigatorio";
            }
            return this.pdadetalhe[field].invalid;
        },
        // Validação ao abrir a tela ao editar e ao salvar
        saveValidations() {
            this.isSaving = true;
            let invalid = false;

            let invalidFields = "";

            // inicia validação dos campos extras
            this.checkValidations = true;
            
            setTimeout(() => {
                if (this.isNull(this.cliente.idclienteerp)) {
                    invalid = true;
                    invalidFields += " - idclienteerp";
                }
                Object.entries(this.extra).forEach(([key, value]) => {
                    if (!value.validated) {
                        invalid = true;
                        invalidFields += " - " + key;
                    }
                });

                this.cliente.extra1 = this.extra.extra1.value;
                this.cliente.extra2 = this.extra.extra2.value;
                this.cliente.extra3 = this.extra.extra3.value;

                this.cliente.estrangeiro =
                    this.estrangeiroSelected != null
                        ? this.estrangeiroSelected.id
                        : null;
                this.cliente.tipocliente =
                    this.pessoaSelected != null
                        ? this.pessoaSelected.id == 1
                            ? "J"
                            : "F"
                        : null;
                this.cliente.contribuinte =
                    this.pessoaSelected.id == 1 &&
                    this.contribuinteSelected &&
                    this.estrangeiroSelected.id == 0
                        ? this.contribuinteSelected.id
                        : null;
                this.cliente.tipoconsumidor =
                    this.tipoConsumidorSelected != null
                        ? this.tipoConsumidorSelected.id
                        : 0;

                // inicia validação dos campos do pdadetalhe
                Object.entries(this.$refs).forEach(([key, value]) => {
                    if (this.pdadetalhe[key]) {
                        this.validadeByPdaDetalhe(key);
                    }
                });
                setTimeout(() => {
                    Object.entries(this.$refs).forEach(([key, value]) => {
                        if (this.pdadetalhe[key]) {
                            if (this.pdadetalhe[key].invalid) {
                                invalid = true;
                                invalidFields += " - " + key;
                            }
                        }
                    });
                    if (invalid) {
                        console.warn("Campos inválidos", invalidFields);
                        // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                        Object.entries(this.$refs).forEach(([key, value]) => {
                            if (value != undefined) value.focusedOut = true;
                        });
                        
                        this.msgs.push( new Message("alert", "msg-campos-obrigatorios", true));
                        
                        this.isLoading = false;
                        this.isSaving = false;
                    } else {
                        // passou por todas as validações
                        this.save();
                    }
                }, 2000);
            }, 1000);
        },
        save() {
            this.isSaving = true;
            this.isLoading = false;

            let clienteTemp = Object.assign({}, this.cliente);
            clienteTemp = this.mapTosave(
                clienteTemp,
                "cnpjcpf",
                "datanascimento",
                "extra1",
                "extra2",
                "extra3"
            );

            if (clienteTemp.estrangeiro == 0) {
                if (clienteTemp.cnpjcpf != null) {
                    clienteTemp.cnpjcpf = clienteTemp.cnpjcpf.replace(
                        /[^0-9]/g,
                        ""
                    );
                }
                if (clienteTemp.cep != null) {
                    clienteTemp.cep = clienteTemp.cep.replace(/[^0-9]/g, "");
                }
            }
            this.saveCliente(clienteTemp)
                .then((value) => {
                    if (value.message == null) {
                        let msg =
                            this.cliente.idcliente != null
                                ? "msg-edit-cliente"
                                : "msg-save-cliente";

                        this.msgs.push(new Message("success", msg, true));


                        setTimeout(() => {
                            this.$emit("isChanged", false);

                            if (!this.isUpdate) this.$emit("isNewToEdit", true);

                            this.$emit('saved', value.content.id);
                        }, 1000);

                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(
                                new Message("alert", value.message, true)
                            );
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    }
                })
                .catch((e) => {
                    if (e.body.status == 409) {
                        this.msgs.push(
                            new Message("alert", e.body.message, true)
                        );
                    } else {
                        console.error("Erro ao salvar: " + e);
                        this.msgs.push(
                            new Message("error", "msg-erro-salvar", true)
                        );
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
        saveCliente(cliente) {
            if(this.isVenda) return this.service.saveVendas(cliente);
            else return this.service.saveAgro(cliente);
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.findCliente()
                .then((body) => {
                    this.cliente = body.content;
                    // para comparação nos modulopdadetalhe com obrigação de alteraçãos
                    this.clienteOld = Object.assign({}, this.cliente);

                    this.isEditStatus = this.statusPermiteEdit.includes(
                        this.cliente.registro_enviado
                    );

                    if (this.cliente.tipocliente != null) {
                        this.pessoaSelected = this.pessoaSelect.filter((f) => {
                            let tempPessoa =
                                this.cliente.tipocliente == "F" ? 0 : 1;
                            return f.id == tempPessoa;
                        })[0];
                    }
                    if (this.cliente.estrangeiro != null) {
                        this.estrangeiroSelected =
                            this.estrangeiroSelect.filter((f) => {
                                return f.id == this.cliente.estrangeiro;
                            })[0];
                    }
                    if (this.cliente.contribuinte != null) {
                        this.contribuinteSelected =
                            this.contribuinteSelect.filter((f) => {
                                return f.id == this.cliente.contribuinte;
                            })[0];
                            this.contribuinteSelected = this.contribuinteSelected ? this.contribuinteSelected : this.contribuinteSelect[2];
                    }
                    if (this.cliente.datanascimento != null) {
                        if (
                            this.$moment(this.cliente.datanascimento).isValid()
                        ) {
                            this.datanascimento = this.$moment(
                                this.cliente.datanascimento
                            ).toDate();
                        }
                    }
                    if (this.cliente.idcidade) {
                        this.loadCidadeById(this.cliente.idcidade);
                    }
                    if (this.cliente.tipoconsumidor != null) {
                        this.tipoConsumidorSelected =
                            this.tipoConsumidorSelect.filter((f) => {
                                return f.id == this.cliente.tipoconsumidor;
                            })[0];
                    }
                    // carrega infos dos selects
                    this.loadCidade();
                    this.loadSituacao();
                    this.loadRegiao();
                    this.loadAtividadeById();
                    this.loadRamo();
                    this.loadMatriz();
                    this.loadTransportadora();
                    this.loadGrupoEconomico();
                    this.loadStatusCliente();

                    this.checkEditTel();
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.isLoadingEdit = false;
                        this.$emit("isChanged", false);
                        this.runValidations(true);
                    }, 700);
                    this.isLoading = false;
                    this.startedMaps = true;
                    if (this.cliente.idcliente != null) this.setExtras();

                    this.$emit("name", this.cliente.nome);
                });
        },
        findCliente() {
            if(this.isVenda) return this.service.findVendas(this.idFrom);
            else return this.service.findAgro(this.idFrom);
        },
        setExtras() {
            this.extra.extra1.value = !this.isNull(this.cliente.extra1)
                ? this.cliente.extra1
                : null;
            this.extra.extra2.value = !this.isNull(this.cliente.extra2)
                ? this.cliente.extra2
                : null;
            this.extra.extra3.value = !this.isNull(this.cliente.extra3)
                ? this.cliente.extra3
                : null;

            setInterval(() => {
                this.showConfigExtra = true;
            }, 300);
        },
        checkEditTel() {
            this.inputFaxEdit = !this.isNull(this.cliente.fax);
            this.inputCelularEdit = !this.isNull(this.cliente.celular);
            this.inputTelefoneEdit = !this.isNull(this.cliente.telefone);
            // setTimeout(() => (this.isLoadingEdit = false), 50);
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    if (value != undefined) value.focusedOut = true;
                });
            }
            /* Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, 
            tendo assim que fazelas manualmente, para poder apresentar os erros nos campos */
            this.customValidations("cnpjcpf");
            this.customValidations("cep");
            this.customValidations("telefone");
            this.customValidations("celular");
            this.customValidations("fax");
            this.customValidations("latitude");
            this.customValidations("longitude");
            this.customValidations("email");
            this.customValidations("emailnfe");
        },
        getInfoByCNPJ() {
            let hasError = false;
            if (this.cidadeSelected == null) {
                this.msgs.push(new Message("error", "msg-erro-pesquisa-cnpj-cidade", true));
                this.pdadetalhe["cidade"].invalid = true;
                this.pdadetalhe["cidade"].msg = "msg-preencha-data-pesquisa-cnpj";
                this.$refs.cidade.focusedOut = true;
                hasError = true;
            }
            if (this.pdadetalhe["cnpjcpf"].invalid) {
                this.msgs.push(new Message("error", "msg-erro-pesquisa-cnpj-invalido", true));
                hasError = true;
            }
            if (!hasError) {
                let uf = this.cidadeSelected.estado;
                let cnpj = this.cliente.cnpjcpf;
                this.isSearchingCNPJ = true;
                this.service
                    .getInfoByCNPJ(uf, cnpj)
                    .then((res) => {
                        if (res.status != 200) {
                            if (res.status == 404) {
                                console.error(`CNPJ ${cnpj} não existe.`);
                                this.msgs.push(new Message("error", "msg-erro-cnpj-inexistente", true));
                            } else {
                                console.error(`Retorno: ${res.status}`);
                                this.msgs.push(new Message("error", "msg-erro-pesquisa-cnpj", true));
                            }
                        } else {
                            let response = JSON.parse(res.content);
                            let data = null;
                            if (typeof response == "object") {
                                response.forEach((e) => { 
                                    if (e.situacao == "1") data = e; 
                                });
                            } else if (response.length > 0) {
                                data = response[response.length - 1];
                            }
                            if (data != null) {
                                if(!this.isNull(data.fantasia)) {
                                    this.cliente.nome = data.fantasia;
                                    this.validadeByPdaDetalhe("nome");
                                } else if (!this.isNull(data.nome)) {
                                    this.cliente.nome = data.nome;
                                    this.validadeByPdaDetalhe("nome");
                                }
                                if (!this.isNull(data.ie)) {
                                    this.cliente.ie = data.ie;
                                    this.validadeByPdaDetalhe("ierg");
                                }
                                this.cliente.rsocial = data.nome;
                                this.cliente.cep = data.cep;
                                this.cliente.endereco = data.logradouro;
                                this.cliente.numero = data.numero;
                                this.cliente.bairro = data.bairro;
                                this.validadeByPdaDetalhe("rsocial");
                                this.validadeByPdaDetalhe("cep");
                                this.validadeByPdaDetalhe("endereco");
                                this.validadeByPdaDetalhe("numero");
                                this.validadeByPdaDetalhe("bairro");
                            } else {
                                this.msgs.push(new Message("error", "msg-erro-pesquisa-cnpj", true));
                            }
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.msgs.push(new Message("error", "msg-erro-pesquisa-cnpj", true));
                    })
                    .finally((_) => {
                        this.isSearchingCNPJ = false;
                    });
            }
        },
        getInfoByCEP() {
            this.validadeByPdaDetalhe("cep");
            if (this.pdadetalhe["cep"].invalid) {
                this.msgs.push(
                    new Message("error", "msg-erro-pesquisa-cep-invalido", true)
                );
            } else {
                let cep = this.cliente.cep;
                this.isSearchingCEP = true;
                let token = this.$moment().format("!%$MM(yyyy)DD*&");
                token = this.$CryptoJS.MD5(token).toString();

                this.service
                    .getInfoByCEP(cep, token)
                    .then((data) => {
                        this.buscaCep = data.content;
                        this.cliente.bairro = data.content.bairro;
                        this.$refs.bairro.focusedOut = false;
                        this.cliente.endereco = data.content.logradouro;
                        this.$refs.endereco.focusedOut = false;
                        this.loadCidade(
                            this.removeAcentos(data.content.cidade)
                        );
                    })
                    .catch((err) => {
                        console.error(err);
                        this.msgs.push(
                            new Message("error", "msg-erro-pesquisa-cep", true)
                        );
                    })
                    .finally((_) => {
                        this.isSearchingCEP = false;
                        // setTimeout(() => (this.isLoadingEdit = false), 50);
                    });
            }
        },
        loadAtividades(searchQuery = "") {
            this.atividadeService
                .findAll(0, 50, searchQuery)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((atividades) => {
                    this.atividadeSelect = Object.assign(atividades);
                    this.atividadeSelect.sort();
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de atividades. Termo: [${searchQuery}]`,
                        e
                    );
                });
        },
        loadAtividadeById() {
            if (this.cliente.idatividade != null) {
                this.atividadeService
                    .find(this.cliente.idatividade)
                    .then((atividade) => {
                        this.atividadeSelected = {
                            id: atividade.content.id,
                            label: atividade.content.descricao,
                        };
                    })
                    .catch((e) => {
                        console.error(
                            `Erro ao realizar pesquisa de atividades. Termo: [${searchQuery}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        this.isLoadingEdit = false;
                    });
            } else {
                this.startedData = true;
            }
        },
        loadSituacao(search = ".*") {
            this.findAll("descricao", "asc", 0, 100, 1, search)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idsituacao,
                            label: m.descricao,
                        };
                    });
                })
                .then((value) => {
                    this.situacaoSelect = value;
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os acertos.");
                })
                .finally((_) => {
                    if (
                        this.situacaoSelect.length > 0 &&
                        this.cliente.idsituacao != null
                    ) {
                        this.situacaoSelected = this.situacaoSelect.filter(
                            (f) => {
                                return f.id == this.cliente.idsituacao;
                            }
                        )[0];
                    }
                    // this.isLoading = false;
                });
        },
        findAll(column, order, page, limit, situacao, ...params) {
            if(this.isVenda) {
                return this.situacaoService
                .findAllVendas(column, order, page, limit, situacao, ...params);
            }else {
                return this.situacaoService
                .findAllAgro(column, order, page, limit, situacao, ...params);
            }
        },
        loadRegiao() {
            this.regiaoService
                .findAllCombo("")
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((regioes) => {
                    this.regiaoSelect = Object.assign(regioes);
                    this.regiaoSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (
                        this.regiaoSelect.length > 0 &&
                        this.cliente.idregiao != null &&
                        this.cliente.idregiao != 0
                    ) {
                        this.regiaoSelected = this.regiaoSelect.filter((f) => {
                            return f.id == this.cliente.idregiao;
                        })[0];
                    }
                });
        },
        loadRamo() {
            this.ramoService
                .findAllCombo("")
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((ramos) => {
                    this.ramoSelect = Object.assign(ramos);
                    this.ramoSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (
                        this.ramoSelect.length > 0 &&
                        this.cliente.idramo != null &&
                        this.cliente.idramo != 0
                    ) {
                        this.ramoSelected = this.ramoSelect.filter((f) => {
                            return f.id == this.cliente.idramo;
                        })[0];
                    }
                });
        },
        loadMatriz() {
            this.service
                .findAllCombo("")
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.nome };
                    });
                })
                .then((matrizes) => {
                    this.matrizSelect = Object.assign(matrizes);
                    this.matrizSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (this.idFrom) {
                        // remove a própria empresa da listagem, pois a mesma não pode ser matriz dela mesma
                        this.matrizSelect.splice(
                            this.matrizSelect.findIndex(
                                (fi) => fi.id == this.idFrom
                            ),
                            1
                        );
                    }
                    if (
                        this.matrizSelect.length > 0 &&
                        this.cliente.idmatriz != null &&
                        this.cliente.idmatriz != 0
                    ) {
                        this.matrizSelected = this.matrizSelect.filter((f) => {
                            return f.id == this.cliente.idmatriz;
                        })[0];
                    }
                });
        },
        loadTransportadora() {
            this.serviceTransportadora
                .findAllCombo("")
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.nome };
                    });
                })
                .then((transportadoras) => {
                    this.transportadoraSelect = Object.assign(transportadoras);
                    this.transportadoraSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (this.idFrom) {
                        // remove a própria empresa da listagem, pois a mesma não pode ser transportadora dela mesma
                        this.transportadoraSelect.splice(
                            this.transportadoraSelect.findIndex(
                                (fi) => fi.id == this.idFrom
                            ),
                            1
                        );
                    }
                    if (
                        this.transportadoraSelect.length > 0 &&
                        this.cliente.idtransportadora != null &&
                        this.cliente.idtransportadora != 0
                    ) {
                        this.transportadoraSelected =
                            this.transportadoraSelect.filter((f) => {
                                return f.id == this.cliente.idtransportadora;
                            })[0];
                    }
                });
        },
        loadGrupoEconomico() {
            this.serviceGrupoEconomico
                .findAllCombo("")
                .then((body) => {
                    return body.content.map((i) => {
                        return { id: i.id, label: i.descricao };
                    });
                })
                .then((gruposeconomicos) => {
                    this.grupoeconomicoSelect = Object.assign(gruposeconomicos);
                    this.grupoeconomicoSelect.sort();
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (
                        this.grupoeconomicoSelect.length > 0 &&
                        this.cliente.idgrupoeconomico != null &&
                        this.cliente.idgrupoeconomico != 0
                    ) {
                        this.grupoeconomicoSelected =
                            this.grupoeconomicoSelect.filter((f) => {
                                return f.id == this.cliente.idgrupoeconomico;
                            })[0];
                    }
                });
        },
        loadCidade(cidade, uf = null) {
            // if ((!cidade && this.cidadeSelected == null) || cidade) {
                this.cidadeService
                    .findAll(0, 100, cidade ? cidade : "")
                    .then((body) => {
                        return body.content.map((i) => {
                            return {
                                id: i.idcidade,
                                cidade: i.cidade,
                                nome: i.descricao,
                                estado: i.estado.descricao,
                            };
                        });
                    })
                    .then((allcidades) => {
                        this.cidadeSelect = Object.assign(allcidades);
                        this.cidadeSelect.sort();
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally((_) => {
                        // foi colocado aqui para a busca com cep funcionar até com conexão fraca a internet
                        if (!this.isNull(this.buscaCep)) {
                            let idcidade = this.cidadeSelect.filter(
                                (s) => s.estado == this.buscaCep.uf
                            );
                            if (idcidade.length > 0) {
                                this.loadCidadeById(idcidade[0].id);
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "alert",
                                        "cidade-nao-encontrada",
                                        true
                                    )
                                );
                            }
                            this.buscaCep = null;
                        } else if (uf != null) {
                            let idcidade = this.cidadeSelect.filter(
                                (s) => s.estado == uf
                            );
                            if (idcidade.length > 0) {
                                this.loadCidadeById(idcidade[0].id);
                            }
                        }
                    });
            // }
        },
        loadCidadeById(id) {
            this.cidadeService
                .find(id)
                .then((cidade) => {
                    if (cidade.content != null) {
                        let temp = {
                            id: cidade.content.id,
                            nome: cidade.content.descricao,
                            estado: cidade.content.estado.descricao,
                            cidade: cidade.content.cidade,
                        };
                        this.cidadeSelected = temp;
                    } else {
                        console.warn("Busca de cidade vazia");
                    }
                }, 350)
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                });
        },
        /**
         * @86384 - criado rota para buscar apenas os status do pedido
         * que podem ser editados, ignorando os restantes
         */
         loadStatusCliente() {
            this.statusLoading = true;
            this.service
                .getStatusClienteComboEdit()
                .then((r) => {
                    if (r.status == 200 && r.content) {
                        r.content.map((e) => {
                            this.statusSelect.push({
                                'id': e,
                                'label': this.getStatus(e)
                            });
                        });
                        // Caso o registro enviado seja em edição, apenas coloco no input, pois essa situação não permite edição
                        if (this.cliente.registro_enviado != "ED" 
                            && this.cliente.registro_enviado !="E" 
                            && this.cliente.registro_enviado != "S" 
                            && this.cliente.registro_enviado !=  "EI") {
                            let tmpStatus = this.statusSelect.filter((e) => e.id == this.cliente.registro_enviado);
                            this.statusSelected = tmpStatus ? tmpStatus[0] : null
                        } else {
                            this.statusSelected = {
                                'id': this.cliente.registro_enviado,
                                'label': this.getStatus(this.cliente.registro_enviado)
                            };
                        }
                    } else {
                        this.statusSelect = null;
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar os status do cliente.", e);
                })
                .finally((_) => {
                    this.statusLoading = false;
                });
        },
        getStatus(status) {
            switch (status) {
                case "E":
                    return this.$t("processando").toUpperCase();
                case "S":
                    return this.$t("transmitido").toUpperCase();
                case "N":
                    return this.$t("nao-enviado").toUpperCase();
                case "C":
                    return this.$t("cancelado").toUpperCase();
                case "A":
                    return this.$t("aprovado").toUpperCase();
                case "F":
                    return this.$t("faturado").toUpperCase();
                case "AP":
                    return this.$t("aguardando-aprovacao").toUpperCase();
                case "ED":
                    return this.$t("em-edicao").toUpperCase();
                case "D":
                    return this.$t("deletado").toUpperCase();
                case "EI":
                    return this.$t("problema-integracao-erp").toUpperCase();
                default:
                    return status === "sem-status"
                        ? this.$t(status).toUpperCase()
                        : status.toUpperCase(); // caso pedido retorno não tenha um status, exibe Sem Status
            }
        },
        updateCidade() {
            this.cliente.idcidade = this.cidadeSelected != null
                ? this.cidadeSelected.id
                : null;
            if (
                !this.isNull(this.cliente.ierg) &&
                this.pessoaSelected.id == 1 &&
                this.estrangeiroSelected.id == 0 &&
                this.contribuinteSelected && 
                this.contribuinteSelected.id != "I"
            ) {
                this.customValidations('ierg');
            }
        },
        copyToWhatsApp() {
            this.copyToWhatsAppActive = true;
            this.cliente.fax = this.cliente.celular;
            this.validadeByPdaDetalhe("fax");
            setTimeout(() => {
                this.copyToWhatsAppActive = false;
            }, 50);
        },
        copyEmail() {
            this.cliente.emailnfe = this.cliente.email;
            this.validadeByPdaDetalhe("emailnfe");
            // setTimeout(() => (this.isLoadingEdit = false), 50);
        },
        openLocationEditor() {
            if (this.isUpdate) {
                if (
                    !this.onlyNumbers(this.cliente.latitude) ||
                    !this.onlyNumbers(this.cliente.longitude)
                ) {
                    this.center.lat = 0;
                    this.center.lng = 0;
                } else {
                    this.center.lat = +this.cliente.latitude;
                    this.center.lng = +this.cliente.longitude;
                }
            }
            if (
                !this.isUpdate &&
                this.isNull(this.cliente.latitude) &&
                this.isNull(this.cliente.longitude) &&
                !this.isNull(this.cidadeSelected)
            ) {
                if (!this.isNull(this.cliente.endereco))
                    this.startSearchWith = this.cliente.endereco;
                if (!this.isNull(this.cliente.numero))
                    this.startSearchWith =
                        this.startSearchWith + " " + this.cliente.numero;
                if (!this.isNull(this.cliente.bairro))
                    this.startSearchWith =
                        this.startSearchWith + " " + this.cliente.bairro;
                if (!this.isNull(this.cidadeSelected.cidade))
                    this.startSearchWith =
                        this.startSearchWith + " " + this.cidadeSelected.cidade;
                if (!this.isNull(this.cidadeSelected.estado))
                    this.startSearchWith =
                        this.startSearchWith + " " + this.cidadeSelected.estado;
                setTimeout(() => {
                    this.$children[this.$children.length - 1].getLocation(
                        this.startSearchWith
                    );
                }, 1000);
            }
            this.locationEditorOpen = true;
        },
        onCancelLocationEditor() {
            this.locationEditorOpen = false;
            this.startSearchWith = "";
        },
        updateLocation(val) {
            this.center.lat = val.center.lat;
            this.center.lng = val.center.lng;
            this.cliente.latitude = this.center.lat;
            this.cliente.longitude = this.center.lng;
            this.onCancelLocationEditor();
            this.validadeByPdaDetalhe("latitude");
            this.validadeByPdaDetalhe("longitude");
            // setTimeout(() => (this.isLoadingEdit = false), 50);
        },

        //funções para fechamento do modal, selecionam o valor adicionado no banco pelo modal
        fecharModalRegiaoWithValue(data = null) {
            if (data != null) {
                let tempRegiao = {
                    id: data.idregiao,
                    label: data.descricao,
                };
                this.regiaoSelect.push(tempRegiao);
                this.regiaoSelected = tempRegiao;
            }
            this.showModalCadastroRegiao = false;
        },
        fecharModalSituacaoWithValue(data = null) {
            if (data != null) {
                let tempSituacao = {
                    id: data.idsituacao,
                    label: data.descricao,
                };
                this.situacaoSelect.push(tempSituacao);
                this.situacaoSelected = tempSituacao;
                this.$emit("isChanged", true)
            }
            this.showModalCadastroSituacao = false;
        },

        fecharModalRegiao() {
            this.showModalCadastroRegiao = false;
            this.$root.showMessage(
                "success",
                "msg-sucesso-ao-adicionar-prazo-pgto"
            );
        },
        fecharModalGrupoEconomico(data = null) {
            if (data != null) {
                let tempGrupoEconomico = { id: data.id, label: data.descricao };
                this.grupoeconomicoSelect.push(tempGrupoEconomico);
                this.grupoEconomicoSelected = tempGrupoEconomico;
                this.isChanged = true;
            }
            this.showModalCadastroGrupoEconomico = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
    .sem-margem-bottom {
        .columns:last-child {
            margin-bottom: 0;
        }
    }
}

.botao-localizacao{
    margin-top: 22px;
    width: 100%;
    height: 40px;
    font-size: 13px;
    padding: 0;
}

@media (max-width: 1460px) {
    .botao-localizacao{
        font-size: 12px;
    }
}

@media (max-width: 1297px) {
    .botao-localizacao{
        font-size: 11px;
    }
}

@media (max-width: 1234px) {
    .botao-localizacao{
        font-size: 10px;
    }
}
</style>